
























































import {Vue, Component} from 'vue-property-decorator';
import AccountService from '@/services/AccountService';
import AccountSummaryForLanguageChange from '@/dto/account/AccountSummaryForLanguageChange';
import PortalSelect from '@/components/common/PortalSelect.vue';
import SelectOption from '@/components/common/SelectOption';
import PaginationComponent from '@/components/util/PaginationComponent.vue';
import Application from '@/state/Application';
import Notifications from '@/state/Notifications';
import {processError} from '@/utils/ComponentUtils';
import {debounce} from 'typescript-debounce-decorator';

@Component({
  components: {
    PortalSelect,
    PaginationComponent
  }
})
export default class CustomersLanguages extends Vue {
  private accounts: Array<AccountSummaryForLanguageChange> = [];
  private currentPage = 0;
  private pageSize = 40;
  private totalPages = 0;
  private searchStr = '';

  private languageOptions: Array<SelectOption> = [
    SelectOption.builder().title('English').value('EN').build(),
    SelectOption.builder().title('Русский').value('RU').build()
  ];
  
  get hasAccounts(): boolean {
    return this.accounts && this.accounts.length > 0;
  }
  
  created(): void {
    this.loadAccounts();
  }

  private loadAccounts(): void {
    Application.startLoading();
    AccountService.getAccountsForLanguageChange(this.currentPage, this.pageSize, this.searchStr).then(
      response => {
        this.accounts = response.data.content;
        this.totalPages = response.data.totalPages || 0;
        Application.stopLoading();
      },
      error => {
        Application.stopLoading();
        processError(error, this);
      }
    );
  }
  
  private changePage(page: number): void {
    this.currentPage = page - 1;
    this.loadAccounts();
  }
  
  private changeLanguage(userId: number, language: string): void {
    // Non-blocking call - no loading indicator
    AccountService.setPreferredLanguage(userId, language);
  }

  @debounce(200)
  private onSearchInput(): void {
    this.currentPage = 0;
    this.loadAccounts();
  }
}
